'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAssignmentV1 = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isAssignmentV1 = exports.isAssignmentV1 = (0, _isType.isType)(_messageTypes.ASSIGNMENT);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isAssignmentV1.js
// module id = 872
// module chunks = 2 3